import React from 'react';
import EventLogo from "./ImagesUpload/EventLogo";
import AttendeeTicketLogo from './ImagesUpload/AttendeeTicketLogo';
import AttendeeInvoiceLogo from './ImagesUpload/AttendeeInvoiceLogo';

const TaxNIncoiveAccordian = ({formik , isRestricted = false}) => {
    return (
       <>
       <div className="row">
       <div className="col-md-6 d-flex flex-column justify-content-center">
           <p className="label mb-0">Attendee Ticket Logo</p>
           <p className="description-text mb-0 mt-2">This logo will be displayed in the footer of attendee ticket.</p>
           <p className="description-text mt-2">(Recommended dimension is 2:1)</p>
       </div>
       <div className="col-md-6">
            <AttendeeTicketLogo formik={formik} isRestricted={isRestricted}/>
       </div>
   </div>
   <div className="row">
       <div className="col-md-6 d-flex flex-column justify-content-center">
           <p className="label mb-0">Attendee Invoice Logo</p>
           <p className="description-text mb-0 mt-2">This logo will be displayed in the footer of registration invoice.</p>
           <p className="description-text mt-2">(Recommended dimension is 2:1)</p>
       </div>
       <div className="col-md-6">
            <AttendeeInvoiceLogo formik={formik} isRestricted={isRestricted} />
       </div>
   </div>
       </>
    )
}

export default TaxNIncoiveAccordian;